<template>
  <b-card>
    <div class="mb-2">
      <h4 class="text-2xl text-black ">
        <strong>Riwayat Broadcast</strong>
      </h4>
    </div>

    <b-row
      v-show="isLoadingCard"
    >
      <b-col>
        <b-skeleton-img class="rounded" />
      </b-col>
      <b-col>
        <b-skeleton-img class="rounded" />
      </b-col>
      <b-col>
        <b-skeleton-img class="rounded" />
      </b-col>
      <b-col>
        <b-skeleton-img class="rounded" />
      </b-col>
    </b-row>
    <div
      v-show="!isLoadingCard"
      class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4"
    >
      <b-card
        v-for="(item, index) in dataCard"
        :key="index"
        class="border"
      >
        <div class="grid gap-8">
          <div class="flex justify-between items-center font-semibold text-base leading-relaxed tracking-wide align-middle">
            <span class="!capitalize">{{ capitalizer(item.template_type) }}</span>
            <!-- <span class="text-[#F95031]">{{ item.total_message_sent }}</span> -->
          </div>
          <div class="flex items-center gap-1">
            <span class="text-[#333333] font-normal text-base leading-relaxed tracking-wide align-middle">IDR{{ IDRWithoutLbl(item.total_cost) }} ({{ item.total_message_sent }})</span>
          </div>
        </div>
      </b-card>
    </div>
    <div class="mt-2 md:w-[35%]">
      <BInputGroup class="input-group-merge">
        <BInputGroupPrepend is-text>
          <b-img
            fluid
            src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/search-normal-1.svg"
            alt="search"
          />
        </BInputGroupPrepend>
        <BFormInput
          v-model="search"
          size="md"
          placeholder="Cari berdasarkan judul"
          style="padding: 8px 1rem"
          @input="handleSearchReceiver()"
        />
      </BInputGroup>
    </div>
    <div>
      <BOverlay
        :show="isLoading"
        spinner-variant="primary"
        variant="light"
        blur="0"
        opacity=".5"
        rounded="sm"
      >
        <BTable
          id="scroll"
          ref="scroll"
          :items="items"
          :fields="fieldsHistoryBroadcastForBrandsTable"
          show-empty
          empty-text="Tidak ada data yang ditampilkan."
          responsive
          sticky-header="500px"
          class="mt-1"
          @scroll.native="handleScroll"
        >
          <template #cell(title)="data">
            <div class="grid">
              <div class="font-normal leading-none tracking-normal  ">
                {{ data.item.title }}
              </div>
              <div class="font-normal mt-[6px] text-[#828282] text-sm leading-none tracking-normal  align-middle">
                {{ moment(data.item.updated_at).format('YYYY-MM-DD HH:mm:ss') }}
              </div>
            </div>
          </template>
          <template #cell(status)="data">
            <div>
              <div
                :class="{'bg-[#FFEDED]': data.item.status === 'FAILED','bg-[#DCF3EB]': data.item.status === 'SENT', 'bg-[#FFF2E2]': data.item.status === 'PENDING' || data.item.status === 'SENDING' }"
                class=" rounded-lg py-[4px]"
              >
                <div
                  :class="{'text-[#E31A1A]': data.item.status === 'FAILED', 'text-[#34A770]': data.item.status === 'SENT', 'text-[#FBA63C]': data.item.status === 'PENDING' || data.item.status === 'SENDING' }"
                  class="text-center text-capitalize  font-[500]"
                >
                  {{ capitalizeWords(data.item.status=== 'SENT'? 'Selesai' : data.item.status) }}
                </div>
              </div>
            </div>
          </template>
          <template #cell(total_contact)="data">
            <div class="flex justify-center">
              <span class="text-primary text-center">{{ data.item.total_contact }}</span>
            </div>

          </template>
          <template #cell(action)="data">
            <div v-show="data.item.status !== 'SENDING'">

              <div>
                <b-dropdown
                  id="dropdown-1"
                  class="filter"
                  no-caret
                  variant="none"
                  toggle-class="text-decoration-none toggle-custom rounded-lg !py-[5px] !px-[10px]"
                  no-close-on-click
                >
                  <template #button-content>
                    <b-icon
                      id="popover-target-1"
                      role="button"
                      icon="three-dots"
                    />
                  </template>
                  <b-dropdown
                    id="dropdown-2"
                    class="w-100"
                    toggle-class="text-left"
                    variant="none"
                    left
                    no-caret
                    dropright
                    menu-class="overflow-y-auto "
                  >
                    <template #button-content>
                      <div class=" flex gap-1 items-center w-100">
                        <div> <b-img src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/send-2.svg" /></div> <div class="text-primary">
                          Resend
                        </div> <b-icon
                          class="text-primary"
                          icon="chevron-right"
                        />
                      </div>
                    </template>
                    <b-dropdown-item @click="handleResend(data.item, 'diff')">
                      <div class="flex gap-1 items-center">
                        <b-icon
                          scale="1.5"
                          icon="plus"
                        />
                        <div>Pilih Penerima Baru</div>
                      </div>
                    </b-dropdown-item>
                    <b-dropdown-item
                      :disabled="!data.item.group_contact_ids"
                      @click="handleResend(data.item, 'same')"
                    >
                      <div class="flex gap-1 items-center">
                        <span class="w-4 h-4 mr-[5px]" />
                        <div>Penerima Sama</div>
                      </div>
                    </b-dropdown-item>
                  </b-dropdown>
                  <b-dropdown-item @click="handleDetail(data.item.id)">
                    Detail
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
          </template>
        </btable>
      </BOverlay>
    </div>
    <ModalSelectReceiver
      :id-template="idTemplate"
      :group-contact-ids-selected="groupContacts"
      @paymentSuccess="handlePaymentSuccess"
    />
  </b-card>
</template>
<script>
import { IDRWithoutLbl } from '@/libs/currency'
import { DAY_MONTH_YEAR } from '@/libs/formatDate'
import moment from 'moment'
import { apiInfoBroadcastForBrand, apiListBroadcastForBrand } from './Broadcast/service/api.broadcast.service'
import { fieldsHistoryBroadcastForBrandsTable, capitalizeWords } from './Broadcast/config'
import ModalSelectReceiver from './Broadcast/components/ModalSelectReceiver.vue'

export default {
  name: 'HistoryBroadcast',
  components: {
    ModalSelectReceiver,
  },
  data() {
    return {
      isLoading: false,
      isLoadingCard: false,
      limit: 15,
      offset: 0,
      isLastData: false,
      dataCard: [],
      items: [],
      fieldsHistoryBroadcastForBrandsTable,
      DAY_MONTH_YEAR,
      IDRWithoutLbl,
      search: '',
      moment,
      capitalizeWords,
      debounce: 0,
      groupContacts: [],
      idTemplate: 0,
    }
  },
  mounted() {
    this.$root.$on('bv::dropdown::show', bvEvent => {
      if (bvEvent.componentId === 'dropdown-2') {
        this.isDropdown2Visible = true
      }
      if (bvEvent.componentId === 'dropdown-3') {
        this.isDropdown2Visible = true
      }
    })
    this.$root.$on('bv::dropdown::hide', bvEvent => {
      if (bvEvent.componentId === 'dropdown-2') {
        this.isDropdown2Visible = false
      }
      if (bvEvent.componentId === 'dropdown-3') {
        this.isDropdown2Visible = false
      }
      if (this.isDropdown2Visible) {
        bvEvent.preventDefault()
      }
    })
    this.getInfoBroadcst()
    this.getHistoryBroadcast()
  },
  methods: {
    capitalizer(str) {
      return str
        .toLowerCase()
        .replace(/\b\w/g, char => char.toUpperCase())
    },
    handleScroll(event) {
      const { scrollTop, scrollHeight, clientHeight } = event.target
      if (scrollTop + clientHeight >= scrollHeight - 1) {
        this.getHistoryBroadcast()
      }
    },
    async getHistoryBroadcast() {
      if (this.isLoading || this.isLastData) return
      try {
        this.isLoading = true
        const { data } = await apiListBroadcastForBrand(this.limit, this.offset, this.search)

        // Pastikan data response valid
        if (data && data.data && Array.isArray(data.data)) {
          // Jika offset = 0 (pencarian baru), replace data. Jika tidak, append data
          if (this.offset === 0) {
            this.items = data.data
          } else {
            this.items = [...this.items, ...data.data]
          }
          this.offset = this.items.length

          // Cek apakah ini adalah data terakhir
          if (data.data.length < this.limit) {
            this.isLastData = true
          }
        } else {
          // Jika data tidak valid, tandai sebagai data terakhir
          this.isLastData = true
        }
      } catch (error) {
        this.$toast_error({
          message: 'Gagal mengambil data history broadcast',
        })
      } finally {
        this.isLoading = false
      }
    },
    async getInfoBroadcst() {
      try {
        this.isLoadingCard = true
        const { data } = await apiInfoBroadcastForBrand()
        this.dataCard = data.data
      } catch {
        this.$toast_error({
          message: 'Gagal mengambil data info broadcast',
        })
      } finally {
        this.isLoadingCard = false
      }
    },
    handleSearchReceiver() {
      clearTimeout(this.debounce)

      // eslint-disable-next-line no-underscore-dangle
      this.debounce = setTimeout(() => {
        // Reset data untuk search baru
        this.items = []
        this.offset = 0
        this.isLastData = false
        this.getHistoryBroadcast()
      }, 2000)
    },
    handleDetail(id) {
      this.$router.push({
        name: 'broadcast-history-detail',
        params: { id },
      })
    },
    handlePaymentSuccess() {
      // this.getHistoryBroadcast()
      this.$bvModal.show('modal-select-receiver')
    },
    handleResend(group, type) {
      if (type === 'same') {
        this.groupContacts = group.group_contact_ids
      } else {
        this.groupContacts = []
      }
      this.idTemplate = group.template_id
      this.$bvModal.show('modal-select-receiver')
    },
  },
}
</script>
